/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';

export default {
    searchRecruitmentPolicy(dataTypeId) {
        return HttpService.get(
            environment.API_RECRUITMENT_PRIVACY_POLICY +
                `?dataSubjectTypeIds=${dataTypeId}`
        );
    },
    saveRecruitmentPolicy(payload) {
        return HttpService.put(
            environment.API_RECRUITMENT_PRIVACY_POLICY,
            payload
        );
    },
    getRecruitmentPolicyDetail(policyId) {
        return HttpService.get(
            environment.API_RECRUITMENT_PRIVACY_POLICY + `/${policyId}`
        );
    },
    getRecruitmentPolicyDetailPublic(policyId) {
        return HttpServiceNoToken.get(
            environment.API_RECRUITMENT_PRIVACY_POLICY_PUBLIC +
                `/publish-version/${policyId}`
        );
    },
    getPublishedVersion(id) {
        return HttpService.get(
            environment.API_RECRUITMENT_PRIVACY_POLICY +
                `/publish-version/` +
                id
        );
    },
    //History
    getHistories(params) {
        return HttpService.get(
            environment.API_RECRUITMENT_PRIVACY_POLICY + `/history`,
            {
                params,
            }
        );
    },
    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_RECRUITMENT_PRIVACY_POLICY + `/history/detail`,
            {
                params,
            }
        );
    },
    deleteRecruitmentPolicy(policyId) {
        return HttpService.delete(
            environment.API_RECRUITMENT_PRIVACY_POLICY + `/${policyId}`
        );
    },

    rename(payload) {
        return HttpService.put(
            environment.API_RECRUITMENT_PRIVACY_POLICY + '/rename',
            payload
        );
    },
};
